import { useState, useMemo, useEffect } from 'react'
import { useIsMobile } from '../../../redux/zustand/useDimensionStore'
import { SIDEBARFULLWIDTH, SIDEBARSMALLWIDTH, SIDEBARDEFAULTMARGIN, WEBHEADERHEIGHT } from '../../../components/customUtils/AppConstants'

export const useResponsiveSidebar = () => {
    const isMobile = useIsMobile()

    // 🔥 Sidebar cerrado por defecto en mobile, abierto en desktop
    const [sidebarOpen, setSidebarOpen] = useState(!isMobile)

    // Cuando cambia el tamaño (mobile ↔ desktop) sincronizamos estado automáticamente
    useEffect(() => {
        setSidebarOpen(!isMobile)
    }, [isMobile])

    const toggleSidebar = () => setSidebarOpen((v) => !v)
    const openSidebar = () => setSidebarOpen(true)
    const closeSidebar = () => setSidebarOpen(false)

    /** -----------------------------
     * SIDEBAR STYLE
     * -----------------------------*/
    const sidebarStyle = useMemo(() => {
        const width = !isMobile ? (sidebarOpen ? SIDEBARFULLWIDTH : SIDEBARSMALLWIDTH) : sidebarOpen ? SIDEBARFULLWIDTH : 0

        return {
            position: isMobile ? 'fixed' : 'relative',
            top: isMobile ? WEBHEADERHEIGHT : 0,
            left: 0,
            display: isMobile ? (sidebarOpen ? 'block' : 'none') : 'block',
            width,

            transform: isMobile ? (sidebarOpen ? 'translateX(0)' : 'translateX(-100%)') : 'translateX(0)',

            height: isMobile ? `calc(100vh - ${WEBHEADERHEIGHT}px)` : '100%',

            transition: 'width 0.25s ease, transform 0.25s ease',
            overflow: 'hidden',

            zIndex: isMobile ? 2000 : 1000,
            backgroundColor: 'white', // para evitar ver contenido detrás al deslizar
        }
    }, [isMobile, sidebarOpen])

    /** -----------------------------
     * MAIN CONTENT STYLE
     * -----------------------------*/
    const contentStyle = useMemo(() => {
        return {
            marginLeft: !isMobile ? SIDEBARDEFAULTMARGIN : 0, // 💥 Mobile siempre cero → evita espacios y glitches

            transition: 'margin-left 0.25s ease',
        }
    }, [isMobile, sidebarOpen])

    /** -----------------------------
     * OVERLAY STYLE (solo mobile)
     * -----------------------------*/
    const overlayVisible = sidebarOpen && isMobile

    const overlayStyle = useMemo(() => {
        if (!overlayVisible) return {}

        return {
            position: 'fixed',
            top: WEBHEADERHEIGHT,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.35)',
            zIndex: 1990, // Debajo del sidebar (2000) pero arriba del contenido
        }
    }, [overlayVisible])

    return {
        isMobile,
        sidebarOpen,
        toggleSidebar,
        openSidebar,
        closeSidebar,

        sidebarStyle,
        contentStyle,
        overlayVisible,
        overlayStyle,
    }
}
